export default __webpack_public_path__ + "static/media/a2.59cbdf10.jpeg";